module.exports = __webpack_public_path__ + "61d08674f0b85be42a3457aba8d6ea04.gif";